export default __webpack_public_path__ + "static/media/logo.8a9e426a.png";